import type { RouteLocationNormalized, RouteRecordRaw } from "vue-router";
import type { Acl, User } from "vue-simple-acl/types/acl";
import { BREADCRUMBS } from "~/core/constants/breadcrumbs";
import { ACLRoles } from "~/core/models/ACLRoles.enum";
import {
  PATH_PARAMETERS_FIRMWARES,
  PATH_PARAMETERS_FIRMWARES_UUID,
} from "~/modules/firmware/constants";

const routes: RouteRecordRaw[] = [
  {
    path: PATH_PARAMETERS_FIRMWARES,
    component: () => import("~/modules/firmware/views/FirmwaresPage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) => can(ACLRoles.CAN_READ_FIRMWARE),
      breadcrumb: BREADCRUMBS.FIRMWARE,
    },
  },
  {
    path: PATH_PARAMETERS_FIRMWARES_UUID,
    component: () => import("~/modules/firmware/views/FirmwaresPage.vue"),
    meta: {
      can: (
        _to: RouteLocationNormalized,
        _from: RouteLocationNormalized,
        can: Acl<User>["can"],
      ) => can(ACLRoles.CAN_READ_FIRMWARE),
      breadcrumb: BREADCRUMBS.FIRMWARE,
    },
  },
];

export default routes;
